import React from "react";
import "./UaeService.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
const UaeServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <p>
        UAE Attestation Services in Bangalore, as offered by Goodway
        Attestation, are comprehensive and cover all the required stages. The
        need for attestation arises primarily for those applying for visas,
        including employment, dependent, family, or student visas. The UAE
        authorities require that all documents—whether academic or personal—be
        duly attested to prevent fraud and ensure compliance with the legal
        standards of the Emirates.
      </p>
      <p>
        Certificate Attestation for UAE in Bangalore involves several important
        stages:
      </p>
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span>1. Personal Document Attestation for UAE: </span>Personal or
          non-educational documents, such as birth certificates, marriage
          certificates, affidavits, and PCC (Police Clearance Certificate), must
          be authenticated initially from the State Home Department. The Home
          Department verifies the origin and legitimacy of the document, after
          which it proceeds to the Ministry of External Affairs (MEA) and
          subsequently to the UAE Embassy. Finally, the document undergoes MOFA
          Attestation in the UAE. This meticulous process ensures that your
          personal credentials are recognized as genuine by the UAE Government.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span>2. Educational Documents Attestation for UAE:</span> If you are
          moving to the UAE for employment or higher studies, your academic
          records, such as degree certificates, diploma certificates, or
          transcripts, must be attested. The first step involves authentication
          from the respective State HRD (Human Resource Development) Department.
          After HRD attestation, the documents are further attested by the
          Ministry of External Affairs (MEA) in India, followed by UAE Embassy
          Attestation in Bangalore. The final phase is MOFA attestation once the
          documents reach UAE.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span> 3. Commercial Document Attestation for UAE: </span>
          For businesses and entrepreneurs planning to operate in the UAE,
          commercial documents such as Articles of Association, Memorandum of
          Association, and Power of Attorney need authentication. The documents
          must first be certified by the Chamber of Commerce, followed by the
          MEA, and finally, attested by the UAE Embassy. MOFA attestation is the
          last step before these documents are deemed legally valid for business
          operations in the UAE.
        </li>
      </ul>
    </div>
  );
};

export default UaeServiceMain;
